export const copyToClipboard = async (url: string) => {
  try {
    await navigator.clipboard.writeText(url);

    setTimeout(() => {
      return true;
    }, 2000);
  } catch (err) {
    const textArea = document.createElement("textarea");
    textArea.value = url;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);

    setTimeout(() => {
      return false;
    }, 2000);
  }
};
